export default {
  loading: false,
  status: false,
  profile: null,
};
